import styled from 'styled-components';
import { Tag } from '@amzn/storm-ui';

export type GtmBadgeColor = 'green' | 'blue' | 'red';

const TEXT_COLOR_MAP: Record<GtmBadgeColor, string> = {
  green: 'green',
  blue: 'blue',
  red: 'red',
};

export const StyledTag = styled(Tag)<{ $color: GtmBadgeColor }>`
  color: ${({ $color, theme }) => theme.color[TEXT_COLOR_MAP[$color]]['700']};
`;
